import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { log } from 'util';
import { DateManagerService } from 'src/app/shared/services/date-manager/date-manager.service';
import { TransactionsService } from '../../../core/functions/transactions.service';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'makaw-areachart',
  templateUrl: './areachart.component.html',
  styleUrls: ['./areachart.component.scss'],
})
export class AreachartComponent implements OnInit, OnDestroy {
  @Input() transaction$: Observable<any[]>;
  private destroyed$ = new Subject();
  public transactions;

  private dates: any[];
  private currentFormatedDate;
  private currentAmount = 0;

  // Presets for charts
  private lineChartData = [{ data: [], label: 'Balance' }];
  public lineChartLabels = [];
  public lineChartOptions = {
    responsive: true,

    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: '18/2/2020',
          borderColor: 'orange',
          borderWidth: 2,
          label: {
            enabled: true,
            fontColor: 'orange',
            content: 'LineAnno',
          },
        },
      ],
    },
  };
  public lineChartColors = [
    {
      borderColor: 'blue',
      backgroundColor: 'rgba(0,0,255,0.3)',
    },
  ];
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];
  public chartReady = false;
  public title = {
    color: '#0000ff',
    rightSection: 'charts.lineChart',
    leftSection: 'transactions.currentBalance',
  };

  constructor(
    private dateManagerService: DateManagerService,
    private transactionService: TransactionsService
  ) {}

  ngOnInit() {
    this.transaction$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((transactions) => {
        this.transactions = transactions;
        this.paintByDay();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  /* Painting methods */
  paintByYear() {
    this.paintGraph(this.dateManagerService.datesFormaterByYear);
  }
  paintByMonth() {
    this.paintGraph(this.dateManagerService.datesFomraterByMonth);
  }
  paintByDay() {
    this.paintGraph(this.dateManagerService.datesFormaterByDay);
  }

  paintGraph(dateFormater) {
    this.dates = this.transactionService.groupAndFormatByDates(
      dateFormater,
      this.transactions
    );
    const transactionsFormated = this.transactionService.transactionsDateFormater(
      dateFormater,
      this.transactions
    );
    this.lineChartData[0].data = this.transactionService.calculateAcumulatedByDates(
      this.dates,
      transactionsFormated
    );

    this.currentAmount = this.transactionService.getBalance(
      this.transactionService.groupByDates(this.transactions),
      this.lineChartData[0].data
    );

    this.chartReady = true;
  }
}
